import { render, staticRenderFns } from "./Baseimg.vue?vue&type=template&id=08ac4506&scoped=true&"
import script from "./Baseimg.vue?vue&type=script&lang=js&"
export * from "./Baseimg.vue?vue&type=script&lang=js&"
import style0 from "./Baseimg.vue?vue&type=style&index=0&id=08ac4506&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ac4506",
  null
  
)

export default component.exports